export default {
  header: "Nous n'avons pas pu charger votre commande",
  text: "Une erreur s'est produite lors de la préparation de votre commande. Votre panier est en sécurité — veuillez réessayer.",
  retry: 'Réessayer',
  address_header: 'Nous avons besoin de votre adresse de livraison',
  address_text:
    'Nous ne pouvons pas calculer votre total tant que nous ne connaissons pas votre lieu de livraison. Votre panier est en sécurité.',
  address_action: 'Ajouter une adresse de livraison',
  back_checkout: 'Retour à votre commande',
  back_basket: 'Retour à votre panier',
};
